module.exports = __webpack_public_path__ + "static/media/Burger_Builder3.6f97d665.png";